import { render } from "./NuevoPrecioComponent.vue?vue&type=template&id=3cf42837&scoped=true"
import script from "./NuevoPrecioComponent.vue?vue&type=script&lang=js"
export * from "./NuevoPrecioComponent.vue?vue&type=script&lang=js"

import "./NuevoPrecioComponent.vue?vue&type=style&index=0&id=3cf42837&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf42837"]])

export default __exports__